/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import useFetcher from "../../../../hooks/useFetcher";
import { formatNumeroDeLegajo } from "../../../course/segmentationClientGropuModal/clientGroupForm";

import { getSubclientsByClientId } from "../../../../services/clientesServices";
import { patchFile, uploadFiles } from "../../../../services/fileServices";
import { BlurSpinner } from "../../../BlurSpinner";
import { TemplateHeader, Container, CustomLabel, InputFile } from "../../styles";
import { InputText } from "../../../../ui/inputs";
import { LabSelect } from "../../../course/select";
import { handleErrors } from "../../../../services/handleErrors";
import { createOrUpdateRelevoDePerfil } from "../RelevoDePerfilForm";
import { getRelevoDePerfilById } from "../../../../services/relevoDePerfilServices";
import CancelFormModal from "../../cancelFormModal";
import { ButtonPrimary } from "../../../../ui/buttons";

export default function UploadRelevoDePerfil({ clientId, toggle, reloadRelevos, relevoId }) {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [subclients, isLoadingSubclients] = useFetcher(getSubclientsByClientId, [clientId]);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [fileName, setFileName] = useState("Seleccione un archivo");
  const [fileId, setFileId] = useState(false);
  const [files, setFiles] = useState(null);
  const [subclientsValues, setSubclientesValues] = useState([]);
  const [valuesFromEdit, setValuesFromEdit] = useState(null);

  useEffect(async () => {
    if (relevoId) {
      const { result } = await getRelevoDePerfilById(relevoId);
      const currentValues = {
        ...result,
      };
      setValuesFromEdit(currentValues);
    }
  }, [relevoId]);

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    setFileName(selectedFiles[0].name);
    setFiles(selectedFiles);
  };

  const uploadOrPatchFiles = async (id) => {
    setIsLoadingFiles(true);

    if (fileId !== false) {
      const file = await patchFile({ entity: "relevoDePerfil", entityId: id, fileId, files });
      setFileId(file.result.id);
    } else {
      const file = await uploadFiles({ entity: "relevoDePerfil", entityId: id, files });
      setFileId(file.result[0].id);
    }
    setIsLoadingFiles(false);
  };

  const subClientOptions =
    subclients && subclients.length > 0
      ? subclients
          .map((e) => {
            return { label: `${formatNumeroDeLegajo(e.numeroDeLegajo)}`, value: e.itemId };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const handleReactSelectChange = (selected) => {
    setSubclientesValues(selected);
  };

  const formik = useFormik({
    initialValues: {
      // TITULO
      clientId,
      subclients: [],
      titulo: "",
      cargo: "",
      template: false,
    },

    onSubmit: async (values) => {
      const dataToCreateRelevo = {
        ...values,
        subclients: subclientsValues.map((e) => e.value),
      };

      try {
        if (subclientsValues.length === 0) {
          toast.error("Debes seleccionar al menos un subcliente.");
          return;
        }
        const { message, result } = await createOrUpdateRelevoDePerfil(dataToCreateRelevo, relevoId);
        await uploadOrPatchFiles(result.id);
        toast.success(message);
        toggle();
        reloadRelevos();
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      titulo: Yup.string().required("Este campo es requerido."),
      cargo: Yup.string().required("Este campo es requerido."),
    }),
  });
  useEffect(() => {
    if (valuesFromEdit) {
      formik.setValues(valuesFromEdit);
      setSubclientesValues(valuesFromEdit.relsRelevoDePerfilSubcliente.map((e) => ({ label: e.numeroDeLegajo, value: e.itemId })));
      if (valuesFromEdit.Files[0]) {
        setFiles(valuesFromEdit.Files[0]);
        setFileName(valuesFromEdit.Files[0].originalname);
        setFileId(valuesFromEdit.Files[0].id);
      }
    }
  }, [valuesFromEdit]);

  return (
    <>
      <CancelFormModal toggle={toggle} closeModal={() => setShowCancelModal(false)} isOpen={showCancelModal} />
      <BlurSpinner>
        <Container>
          <form onSubmit={formik.handleSubmit}>
            <div>
              <div className="d-flex flex-column justify-content-between align-items-start">
                {/* TITULO */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1 ">
                    <TemplateHeader> Título </TemplateHeader>
                  </div>
                  <div>
                    <div className="mb-1">
                      <InputText
                        type="text"
                        id="titulo"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.titulo}
                        maxLength={40}
                        placeholder={formik.errors.titulo && formik.touched.titulo ? formik.errors.titulo : ""}
                        style={formik.errors.titulo && formik.touched.titulo ? { borderBottom: "1px solid red" } : null}
                      />
                    </div>

                    <div className="mb-3" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", zIndex: 10 }}>
                      <div className="mb-1">
                        <CustomLabel>Subcliente</CustomLabel>
                        <LabSelect
                          isMulti
                          id="subclients"
                          name="subclients"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={subclientsValues}
                          placeholder="seleccionar"
                          isClearable
                          isLoading={isLoadingSubclients}
                          disabled={isLoadingSubclients || formik.isSubmitting}
                          options={subClientOptions}
                        />
                      </div>

                      <div className="mb-1">
                        <CustomLabel>Cargo</CustomLabel>
                        <InputText
                          type="text"
                          id="cargo"
                          disabled={formik.isSubmitting}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.cargo}
                          maxLength={40}
                          placeholder={formik.errors.cargo && formik.touched.cargo ? formik.errors.cargo : null}
                          style={formik.errors.cargo && formik.touched.cargo ? { borderBottom: "1px solid red", placeholder: "red" } : null}
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <div className="custom-file">
                        <InputText
                          className="custom-file-input"
                          type="file"
                          id="upfile"
                          onChange={handleFileChange}
                          accept=".pdf, .xls, .xlsx, .doc, .docx, .jpg, .jpeg, .png"
                          style={{ cursor: "pointer", border: "none" }}
                          disabled={formik.isSubmitting}
                        />
                        <InputFile className="custom-file-label" htmlFor="upfile">
                          {fileName}
                        </InputFile>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ------- */}
              </div>
              <div className="d-flex justify-content-end">
                <Button className="mr-2" size="sm" color="btn" type="button" onClick={() => setShowCancelModal(true)}>
                  Cancelar
                </Button>
                <ButtonPrimary size="sm" className="btn" type="submit" disabled={formik.isSubmitting || isLoadingFiles || !files}>
                  Guardar
                </ButtonPrimary>
              </div>
            </div>
          </form>
        </Container>
      </BlurSpinner>
    </>
  );
}
